/**
 * @file OB・OGメール重複モーダル
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname MailDuplicationModal
 * @classdesc OB・OGメール重複モーダル
 */
export default class MailDuplicationModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-exemption')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const val = $e.val();
		if(val === '1') {
			Common.showErrorModal('このメールアドレスは既に登録されています。');
		}
	};
}
